import { Module } from 'vuex-module-decorators'
import ModalAlertStore from '@/store/ModalAlertStore'

@Module({
  name: 'ModalReturnCheckAlertStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalReturnCheckAlertStore extends ModalAlertStore {}
